/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { CustomFieldPlacement, CustomFieldType } from '../../custom-fields';
import { globalDictionaries } from '@gh/common-shared';

export const ContactDeliveryMethod = createEnum('CONTACT_DELIVERY_METHOD', {
  Mail: 'MAIL',
  Email: 'EMAIL',
});
export type ContactDeliveryMethod = EnumSet<typeof ContactDeliveryMethod>;

export const ContactPayBy = createEnum('PAY_BY', {
  Cash: 'CASH',
  Cheque: 'CHEQUE',
  CreditCard: 'CREDIT_CARD',
  DirectCredit: 'DIRECT_CREDIT',
});

export type ContactPayBy = EnumSet<typeof ContactPayBy>;

export const ContactPaidBy = createEnum(globalDictionaries.paidBy, {
  Check: 'CHECK',
  BankCredit: 'BANK_CREDIT',
  DirectCredit: 'DIRECT_CREDIT',
  BPay: 'B_PAY',
});

export type ContactPaidBy = EnumSet<typeof ContactPaidBy>;

export const ContactTermsPayables = createEnum('TERMS_PAYABLES', {
  NoneAdvised: 1,
  COD: 2,
  Prepaid: 3,
  InDays: 4,
  OnMonthDay: 5,
  DaysAfterEOM: 6,
  MonthDayAfterEOM: 7,
});

export type ContactTermsPayables = EnumSet<typeof ContactTermsPayables>;

export const ContactTermsReceivables = createEnum('TERMS_RECEIVABLES', {
  NoneAdvised: 1,
  COD: 2,
  Prepaid: 3,
  InDays: 4,
  OnMonthDay: 5,
  DaysAfterEOM: 6,
  MonthDayAfterEOM: 7,
  DueUponReceipt: 8,
});

export type ContactTermsReceivables = EnumSet<typeof ContactTermsReceivables>;

export type ContactDetailsCustomFieldListDto = {
  data: ContactDetailsCustomFieldItemDto[];
};

export type ContactDetailsCustomFieldItemDto = {
  customFieldId: ID;
  name: string;
  dataType: CustomFieldType;
  customFieldPlacement: CustomFieldPlacement;
  required: boolean;
  customFieldValueId?: ID;
  textValue?: string;
  dateValue?: Date;
  numberValue?: string;
  digitsLength?: number;
  decimalPlaces?: number;
};

export type ContactDetailsPaymentPayerDto = {
  payBy: ContactPayBy;
  bsbNumber: string;
  accountNumber: string;
  accountName: string;
};

export type ContactDetailsTermsPayerDto = {
  paymentIsDue: ContactTermsReceivables;
  dueDays: number;
  discountDays: number;
  discountPct: number;
};

export type ContactDetailsPaymentPayeeDto = {
  paidBy: ContactPaidBy;
  bsbNumber: string;
  accountNumber: string;
  accountName: string;
  abn?: string;
};

export type ContactDetailsPaymentCreditorDto = {
  paidBy: ContactPaidBy;
  bsbAccountNumber: string;
  accountName: string;
  abn?: string;
};

export type ContactDetailsTermsPayeeDto = {
  paymentIsDue: ContactTermsPayables;
  dueDays: number;
  discountDays: number;
  discountPct: number;
};
